import { useMemo } from 'react';
import _ from 'lodash';
import { UserDTO } from 'src/api';
import { ReporterStatusEnum, RoleEnum } from 'src/api/models/Enums';
import { useQuery } from '@tanstack/react-query';
import { useApiClient } from 'src/hooks/useApiClient';

export function useReporters({ enabled }: { enabled: boolean }) {
	const { apiClient } = useApiClient();

	const { data, isLoading, error, refetch } = useQuery<UserDTO[]>({
		queryKey: ['reporters_list'],
		queryFn: async () => {
			return apiClient.userController.getRegisterUsersSegnalatore();
		},
		enabled,
		refetchOnWindowFocus: false,
		retry: false,
	});

	const approvalCount = useMemo(() => {
		if (!data) return 0;
		return (data || []).filter(
			(item) => item?.role === RoleEnum.SEGNALATORE
			&& (item?.status?.toUpperCase() === ReporterStatusEnum.PENDING)
		).length;
	}, [data]);

	return {
		reporters: data || [],
		approvalCount,
		isLoadingReporters: isLoading,
		reportersError: error,
		refetchReporters: refetch,
	};
}
